// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { xBaseTheme } from "@synd/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            size: fontConfig.smallSingleLine.size,
            color: "common.ui7",
            weight: "normal",
            css: css`
                letter-spacing: 0;
                line-height: ${fontConfig.smallSingleLine.lineHeight};
                max-width: 100%;
                word-wrap: break-word;
            `,
        },
        css: css`
            flex-wrap: wrap;
            gap: 8px;
        `,
    },
} as xBaseTheme["breadcrumbs"];
